import {
  Table as TableComponent,
  TableContainer,
  TableHeaderCell,
  TableRow,
} from '@spotify-internal/encore-web';

interface TableProps {
  headers: (string | JSX.Element)[];
  widths?: string[];
  hasExpandColumn?: boolean;
  expandColumnWidth?: string;
  children: React.ReactNode;
}

export const Table = ({
  headers,
  widths = [],
  hasExpandColumn = false,
  expandColumnWidth,
  children,
}: TableProps) => {
  return (
    <>
      <TableContainer id="tracks-table-container">
        <TableComponent>
          <colgroup>
            {hasExpandColumn && <col width={expandColumnWidth} />}
            {headers.map((header, index) => (
              <col width={widths[index]} key={`col-${header}-${index}`} />
            ))}
          </colgroup>
          <thead>
            <TableRow>
              {hasExpandColumn && <td>{/** left blank intentionally */}</td>}
              {headers.map((header, index) => {
                if (!header) {
                  return <td key={`header-cell-${index}`} />;
                }

                return typeof header === 'string' ? (
                  <TableHeaderCell key={`header-cell-${index}`}>
                    {header}
                  </TableHeaderCell>
                ) : (
                  header
                );
              })}
            </TableRow>
          </thead>
          <tbody>{children}</tbody>
        </TableComponent>
      </TableContainer>
    </>
  );
};
